/**
 * Trust pills (cart drawer + PDP) — single note panel, plain-text FAQ content.
 * Document delegation survives cart-drawer section re-renders.
 */
(function () {
  if (window.__plumelleCartTrustBound) return;
  window.__plumelleCartTrustBound = true;

  function closestEl(start, selector) {
    var el = start;
    if (el && el.nodeType === 3) el = el.parentElement;
    if (!el) return null;
    if (typeof el.closest === "function") return el.closest(selector);
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function rootFrom(el) {
    return (
      closestEl(el, "[data-trust-root]") ||
      closestEl(el, "[data-cart-trust-root]")
    );
  }

  function getData(root) {
    if (root.__trustData) return root.__trustData;
    var node = root.querySelector("[data-trust-json]");
    if (!node) return null;
    try {
      root.__trustData = JSON.parse(node.textContent);
    } catch (e) {
      root.__trustData = null;
    }
    return root.__trustData;
  }

  function setPills(root, activeKey) {
    root.querySelectorAll("[data-trust-open]").forEach(function (pill) {
      var on = pill.getAttribute("data-trust-open") === activeKey;
      pill.setAttribute("aria-expanded", on ? "true" : "false");
      pill.classList.toggle("is-active", on);
    });
  }

  function closeNote(root) {
    if (!root) return;
    root.setAttribute("data-trust-active", "");
    setPills(root, "");
    var note = root.querySelector("[data-trust-note]");
    if (!note) return;
    note.hidden = true;
    note.setAttribute("hidden", "");
  }

  function openNote(root, key) {
    if (!root || !key) return;
    var data = getData(root);
    var entry = data && data[key];
    var note = root.querySelector("[data-trust-note]");
    if (!entry || !note) return;

    var current = root.getAttribute("data-trust-active") || "";
    // Same pill again → close
    if (current === key) {
      closeNote(root);
      return;
    }

    var titleEl = note.querySelector("[data-trust-title]");
    var bodyEl = note.querySelector("[data-trust-body]");
    var linkEl = note.querySelector("[data-trust-link]");

    if (titleEl) titleEl.textContent = entry.title || "";
    if (bodyEl) {
      bodyEl.textContent = "";
      var p = document.createElement("p");
      p.textContent = entry.body || "";
      bodyEl.appendChild(p);
    }
    if (linkEl) {
      linkEl.href = entry.href || "#";
      if (data.viewFaq) linkEl.textContent = data.viewFaq;
    }

    root.setAttribute("data-trust-active", key);
    setPills(root, key);
    note.hidden = false;
    note.removeAttribute("hidden");
    note.setAttribute("aria-label", entry.title || "");
  }

  function onActivate(event) {
    var target = event.target;
    if (!target) return;

    var closeBtn = closestEl(target, "[data-trust-close]");
    if (closeBtn) {
      var rootClose = rootFrom(closeBtn);
      if (!rootClose) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      closeNote(rootClose);
      return;
    }

    var openBtn = closestEl(target, "[data-trust-open]");
    if (openBtn) {
      var root = rootFrom(openBtn);
      if (!root) return;
      event.preventDefault();
      event.stopPropagation();
      openNote(root, openBtn.getAttribute("data-trust-open"));
    }
  }

  document.addEventListener("click", onActivate, true);

  /**
   * Hide fixed third-party FABs (e.g. DE ChatArmin) while cart is open.
   */
  var blockedNodes = [];

  function clearBlockedLayers() {
    blockedNodes.forEach(function (entry) {
      if (!entry.el || !entry.el.style) return;
      entry.el.style.pointerEvents = entry.pe;
      entry.el.style.visibility = entry.vis;
    });
    blockedNodes = [];
  }

  function blockFloatingLayers() {
    clearBlockedLayers();
    var drawer = document.querySelector("cart-drawer.drawer");
    var nodes = document.body ? document.body.children : [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el === drawer || (drawer && drawer.contains(el))) continue;
      if (el.id === "CartDrawer" || (el.classList && el.classList.contains("drawer"))) continue;
      // Keep free-gift claim toast visible above the open cart drawer
      if (el.classList && el.classList.contains("plumelle-fg-toast")) continue;
      if (el.hasAttribute && el.hasAttribute("data-fg-toast")) continue;
      var style = window.getComputedStyle(el);
      if (style.position !== "fixed" && style.position !== "sticky") continue;
      var z = parseInt(style.zIndex, 10);
      if (!z || z < 1000) continue;
      var rect = el.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) continue;
      var nearBottomRight =
        rect.right > window.innerWidth * 0.55 &&
        rect.bottom > window.innerHeight * 0.45;
      if (!nearBottomRight && z < 10000) continue;
      blockedNodes.push({
        el: el,
        pe: el.style.pointerEvents,
        vis: el.style.visibility,
      });
      el.style.pointerEvents = "none";
      el.style.visibility = "hidden";
    }
  }

  function syncCartLayerBlock() {
    if (!document.body) return;
    var open =
      document.body.classList.contains("cart-overflow-hidden") ||
      !!document.querySelector("cart-drawer.drawer.active");
    if (open) blockFloatingLayers();
    else clearBlockedLayers();
  }

  function watchCartLayers() {
    if (!document.body) return;
    var mo = new MutationObserver(syncCartLayerBlock);
    mo.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
      childList: true,
    });
    document.addEventListener("cart:updated", syncCartLayerBlock);
    setTimeout(syncCartLayerBlock, 0);
  }

  if (document.body) watchCartLayers();
  else document.addEventListener("DOMContentLoaded", watchCartLayers);
})();
